"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const enums_1 = require("./common/enums");
const react_1 = require("react");
const validator_1 = require("./utils/validator");
const Calendar_1 = __importDefault(require("./Calendar"));
const ConfigLayer_1 = __importDefault(require("./layers/ConfigLayer"));
const DimensionsLayoutLayer_1 = __importDefault(require("./layers/DimensionsLayoutLayer"));
const LanguageLayer_1 = __importDefault(require("./layers/LanguageLayer"));
const RootLayoutLayer_1 = __importDefault(require("./layers/RootLayoutLayer"));
const store_1 = __importDefault(require("./context/store"));
exports.CalendarView = enums_1.CALENDAR_VIEW;
// use any as JSX was causing errors for some cases
const Kalend = (props) => {
    // basic validation
    (0, react_1.useEffect)(() => {
        (0, validator_1.validateProps)(props);
        (0, validator_1.validateStyle)(props.testMode);
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__Calendar__root Kalend__main' }, { children: (0, jsx_runtime_1.jsx)(store_1.default, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)(LanguageLayer_1.default, Object.assign({ language: props.language || 'en', customLanguage: props.customLanguage }, { children: (0, jsx_runtime_1.jsx)(RootLayoutLayer_1.default, { children: (0, jsx_runtime_1.jsx)(ConfigLayer_1.default, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)(DimensionsLayoutLayer_1.default, { children: (0, jsx_runtime_1.jsx)(Calendar_1.default, { kalendRef: props.kalendRef, events: props.events, eventLayouts: props.eventLayouts, selectedView: props.selectedView, initialDate: props.initialDate }) }) })) }) })) })) })));
};
exports.default = Kalend;
